import { render, staticRenderFns } from "./ArtGuideEventsReorderControlActions.vue?vue&type=template&id=b4a545de&scoped=true&"
import script from "./ArtGuideEventsReorderControlActions.vue?vue&type=script&lang=js&"
export * from "./ArtGuideEventsReorderControlActions.vue?vue&type=script&lang=js&"
import style0 from "./ArtGuideEventsReorderControlActions.vue?vue&type=style&index=0&id=b4a545de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4a545de",
  null
  
)

export default component.exports